import { useState, useCallback } from 'react';
import axios from 'axios';

export const useItalianCities = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchCities = useCallback(async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 1) {
      setCities([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axios.get('/v1/check-cities-cap-state-ax', {
        params: {
          search: searchTerm
        }
      });
      
      console.log('API Response:', response.data);
      
      // La tua API restituisce direttamente un array
      const citiesData = Array.isArray(response.data) ? response.data : [];
      setCities(citiesData);
      
      console.log('Cities set:', citiesData);
    } catch (err) {
      console.error('Error fetching cities:', err);
      setError(err.message);
      setCities([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    cities,
    loading,
    error,
    searchCities
  };
};
